module.exports = __webpack_public_path__ + "static/media/face-unsure-filled.b1a6a8bd.svg";